import ContentLoader from "react-content-loader";
import {useMediaQuery} from "@material-ui/core";

export const PieChartLoader=(props)=>(
    <ContentLoader
        speed={2}
        width={300}
        height={350}
        viewBox="0 0 300 350"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <circle cx="161" cy="229" r="115" />
        <rect x="47" y="15" rx="0" ry="0" width="221" height="17" />
        <rect x="45" y="61" rx="0" ry="0" width="24" height="9" />
        <rect x="79" y="57" rx="0" ry="0" width="56" height="15" />
        <rect x="117" y="87" rx="0" ry="0" width="24" height="9" />
        <rect x="150" y="84" rx="0" ry="0" width="56" height="15" />
        <rect x="174" y="60" rx="0" ry="0" width="24" height="9" />
        <rect x="208" y="56" rx="0" ry="0" width="56" height="15" />
    </ContentLoader>
)

export const StatsLoader = (props) => (
    <ContentLoader
        speed={2}
        width={100}
        height={100}
        viewBox="0 0 100 100"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
        <rect x="12" y="24" rx="0" ry="0" width="71" height="32" />
        <rect x="21" y="70" rx="0" ry="0" width="53" height="11" />
    </ContentLoader>
)

export const BarChartLoader=(props)=>(
            <ContentLoader width={300} height={300} viewBox="0 0 300 350" {...props}>.
                <rect x="100" y="100" rx="0" ry="0" width="100" height="15" />
                <rect x="0" y="320" rx="0" ry="0" width="50" height="80" />
                <rect x="55" y="290" rx="0" ry="0" width="50" height="110" />
                <rect x="110" y="251" rx="0" ry="0" width="50" height="148" />
                <rect x="165" y="160" rx="0" ry="0" width="50" height="240" />
                <rect x="220" y="284" rx="0" ry="0" width="50" height="116" />
            </ContentLoader>
);


// ANALYSES DES MODULES SUB COMPOUNENTS
export const  ModulesCardsLoader= () => {
    return (
        <div className="w-100 justify-content-center d-flex flex-column align-items-center">
            <FadingLoaderCard1 />
            <FadingLoaderCard2 />
            <FadingLoaderCard3 />
            <FadingLoaderCard4 />
            <FadingLoaderCard5 />
        </div>
    )
}

const FadingLoaderCard1 = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
        return (
            <ContentLoader
                width={lg ? 800 : 300}
                height={40}
                backgroundColor="#ababab"
                foregroundColor="#fafafa"
                className="mb-2"
                // style={{width : '70%'}}
            >
                <rect x={ lg ? "130" : "70"} y="15" rx="5" ry="5" width={ lg ? "800" : "300" } height="15" />
                <rect x={ lg ? "130" : "70"} y="39" rx="5" ry="5" width={ lg ? "700" : "200" } height="9" />
                <rect x="20" y="10" rx="0" ry="0" width={ lg ? "100" : "40" } height="40" />
            </ContentLoader>
        )

}

const FadingLoaderCard2 = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    return (
        <ContentLoader
            width={lg ? 800 : 300}
            height={40}
            backgroundColor="#bfbfbf"
            foregroundColor="#fafafa"
            className="mb-2"

        >
            <rect x={ lg ? "130" : "70"} y="15" rx="5" ry="5" width={ lg ? "800" : "300" } height="15" />
            <rect x={ lg ? "130" : "70"} y="39" rx="5" ry="5" width={ lg ? "700" : "200" } height="9" />
            <rect x="20" y="10" rx="0" ry="0" width={ lg ? "100" : "40" } height="40" />
        </ContentLoader>
    )
}

const FadingLoaderCard3 = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    return (
        <ContentLoader
            width={lg ? 800 : 300}
            height={40}
            backgroundColor="#dadada"
            foregroundColor="#fafafa"
            className="mb-2"

        >
            <rect x={ lg ? "130" : "70"} y="15" rx="5" ry="5" width={ lg ? "800" : "300" } height="15" />
            <rect x={ lg ? "130" : "70"} y="39" rx="5" ry="5" width={ lg ? "700" : "200" } height="9" />
            <rect x="20" y="10" rx="0" ry="0" width={ lg ? "100" : "40" } height="40" />
        </ContentLoader>
    )
}

const FadingLoaderCard4 = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    return (
        <ContentLoader
            width={lg ? 800 : 300}
            height={40}
            backgroundColor="#ececec"
            foregroundColor="#fafafa"
            className="mb-2"

        >
            <rect x={ lg ? "130" : "70"} y="15" rx="5" ry="5" width={ lg ? "800" : "300" } height="15" />
            <rect x={ lg ? "130" : "70"} y="39" rx="5" ry="5" width={ lg ? "700" : "200" } height="9" />
            <rect x="20" y="10" rx="0" ry="0" width={ lg ? "100" : "40" } height="40" />
        </ContentLoader>
    )
}

const FadingLoaderCard5 = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    return (
        <ContentLoader
            width={lg ? 800 : 300}
            height={40}
            backgroundColor="#f7f7f7"
            foregroundColor="#fafafa"
            className="mb-2"

        >
            <rect x={ lg ? "130" : "70"} y="15" rx="5" ry="5" width={ lg ? "800" : "300" } height="15" />
            <rect x={ lg ? "130" : "70"} y="39" rx="5" ry="5" width={ lg ? "700" : "200" } height="9" />
            <rect x="20" y="10" rx="0" ry="0" width={ lg ? "100" : "40" } height="40" />
        </ContentLoader>
    )
}


export const WeekStrongPointsButtonsLoaders=(props)=>{
    return(
        <ContentLoader
            speed={2}
            width={250}
            height={60}
            viewBox="0 0 250 60"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="18" y="4" rx="0" ry="0" width="200" height="30" />
            <rect x="43" y="44" rx="0" ry="0" width="150" height="10" />
        </ContentLoader>
    )
}
